import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import { ColumnSortOrderEnum, ExpandableTable, PendingButton } from "@ploy-ui/core";
import { LinearProgress, Grid, Paper } from "@material-ui/core";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { WholesaleOverviewStatus } from "./WholesaleOverviewStatus";
import { WholesaleOverviewCheckbox } from "./WholesaleOverviewCheckbox";
import { WholesaleOverviewSummaryDownloader } from "./WholesaleOverviewSummaryDownloader";
const WholesaleOverviewApplications = (props) => {
    const { cars, redeemApplications } = props;
    return (_jsx(Paper, { style: {
            left: "10%",
            right: "10%"
        }, elevation: 3, children: _jsx(ExpandableTable, { idColumn: "ApplicationNumber", tableData: cars, columnData: columnData, expandable: true, tableIsSortable: true, renderExpandedSection: datarow => (_jsx(Suspense, { fallback: _jsx(LinearProgress, {}), children: _jsxs(Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "flex-start", style: { padding: "0.5em" }, children: [_jsx(Grid, { item: true, style: { padding: "1em", justifyContent: "center" }, children: _jsx(FormattedMessage, { id: "vendor.wholesale.click-to-fulfill", description: "Click to fulfill", defaultMessage: "Click \u00ABFulfill withdrawal\u00BB to fulfill withdrawal. Amount automatically be withdrawn from your account." }) }), _jsx(Grid, { item: true, children: _jsx(PendingButton, { onClick: () => {
                                    redeemApplications([datarow]);
                                }, color: "secondary", variant: "contained", disabled: datarow.DaysUntilEndDateStatus === "black" ||
                                    datarow.Status !== 5, children: _jsx(FormattedMessage, { id: "vendor.wholesale.fulfill-button", description: "Fulfill button", defaultMessage: "Fulfill withdrawal" }) }) })] }) })) }) }));
};
const columnData = [
    {
        id: "WholesaleOverviewCheckbox",
        label: _jsx(WholesaleOverviewSummaryDownloader, {}),
        component: props => _jsx(WholesaleOverviewCheckbox, { ...props.rowData }),
        sortOrder: ColumnSortOrderEnum.Disabled
    },
    {
        id: "DaysUntilEndDate",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-status", defaultMessage: "Status" })),
        component: props => _jsx(WholesaleOverviewStatus, { ...props.rowData })
    },
    {
        id: "ApplicationNumber",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-appno", defaultMessage: "App. number" }))
    },
    {
        id: "ObjectDescription",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-desc", defaultMessage: "Description" }))
    },
    {
        id: "RegistrationNumber",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-regno", defaultMessage: "Reg. number" }))
    },
    {
        id: "ChassiNumber",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-chassis", defaultMessage: "Chassis number" }))
    },
    {
        id: "EndDate",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-enddate", defaultMessage: "End date" }))
    },
    {
        id: "LoanAmount",
        label: (_jsx(FormattedMessage, { id: "vendor.wholesale.fulfillment-list-loanamount", defaultMessage: "Loan amount" })),
        component: props => (_jsxs("div", { children: [_jsx(FormattedNumber, { value: props.rowData.LoanAmount, maximumFractionDigits: 0 }), ",-"] }))
    }
];
export { WholesaleOverviewApplications };
//# sourceMappingURL=WholesaleOverviewApplications.js.map